import React, { useEffect, useState } from "react";
import MaterialTable from "../../Components/Table/MaterialTable";
import Header from "../../Components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { leftArrow, userarrow } from "../../common/Assets/imgs";
import toast from "react-hot-toast";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

const ViewUsers = () => {
  const location = useLocation();
  console.log("location", location);
  const data = location?.state?.data;
  console.log(data, "data");
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [usertype, setUserType] = useState(data?.special_user);
  const [adminData,setAdminData]=useState([]);
  const trips = [
    {
      sno: "01",
      orderId: "KL075821",
      pickup: "Chennai",
      drop: "Bangalore",
      price: "₹12000",
      datetime: "10-12-2025 , 1:00 PM",
      status: "Pending",
    },
    {
      sno: "02",
      orderId: "KL075822",
      pickup: "Kerala",
      drop: "Hyderabad",
      price: "₹20000",
      datetime: "10-12-2025 , 1:00 PM",
      status: "Delivered",
    },
    {
      sno: "03",
      orderId: "KL075823",
      pickup: "Kochi",
      drop: "Chennai",
      price: "₹35000",
      datetime: "10-12-2025 , 1:00 PM",
      status: "Delivered",
    },
    {
      sno: "04",
      orderId: "KL075824",
      pickup: "Bangalore",
      drop: "Chennai",
      price: "₹16000",
      datetime: "10-12-2025 , 1:00 PM",
      status: "Cancelled",
    },
    {
      sno: "05",
      orderId: "KL075825",
      pickup: "Mangalore",
      drop: "Kerala",
      price: "₹40000",
      datetime: "10-12-2025 , 1:00 PM",
      status: "Delivered",
    },
    {
      sno: "06",
      orderId: "KL075826",
      pickup: "Chennai",
      drop: "Coimbatore",
      price: "₹35000",
      datetime: "10-12-2025 , 1:00 PM",
      status: "Delivered",
    },
  ];

  const columns = [
    // {
    //   accessorKey: "sno",
    //   header: "S.No",
    // },
      {
      header: "S.No",
      accessorFn: (row, index) => index + 1,
      id: "serial_no",
    },
    {
      accessorKey: "order_id",
      header: "Order ID",
    },
    {
      accessorKey: "pickup",
      header: "Pickup",
       Cell: ({ cell }) => {
        const value = cell.getValue();
        return value?.length > 20 ? value.substring(0, 20) + "..." : value;
      },
    },
    {
      accessorKey: "drop",
      header: "Drop",
        Cell: ({ cell }) => {
        const value = cell.getValue();
        return value?.length > 20 ? value.substring(0, 20) + "..." : value;
      },
    },
    {
      accessorKey: "trip_price",
      header: "Trip Price",
    },
    {
      accessorKey: "date_time",
      header: "Date & Time",
    },
    {
      accessorKey: "status",
      header: "Status",
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return (
          // <div className={`${value === "Active" ? 'statusactive' : 'statusdeactive'}`} >
          <span
            className={
              value === "Assigned"
                ? "text-primary"
                : value === "Requested"
                  ? "text-warning"
                  : "text-success"
            }
          >
            {value}
          </span>
          // </div>
        );
      },
    },
  ];

  console.log("data.image", data.image);

  const handleLogout = async (user) => {
    const postData = {
      user_id: data?.id,
      special_user: user ? false : true,
    };

    try {
      setLoading(true);
      setIsLoading(true);

      const res = await post(URLS.USER_SPECIALUSER, postData);

      if (res?.status === "success") {
        setUserType(!user);
        toast.success("User changed successfully");
        setPopup(false);
        setIsLoading(false);
      } else {
        toast.error(res?.message || "Something went wrong");
      }
    } catch (error) {
      console.log(error);
      toast.error("API Error");
    } finally {
      setLoading(false);
      setIsLoading(false);
    }
  };

  const getList = async() =>{
    try {
    const res = await get(`${URLS.USER_PASTTRIPS}${data?.id}/`)
    console.log('res',res);
    if(res?.status === "success") {
      setAdminData(res?.data || [])
    }
    }
    catch(err){
        console.log("err",err);
    }
  }

  useEffect(()=>{
getList();
  },[])


  return (
    <>
      <Header />
      {/* <div style={{marginTop:'7rem',paddingLeft:'10px',paddingRight:'10px' }}> */}

      {/* <PageHeader
                    title="FAQ"
                    showBackButton={true}
                    onBackClick={() => navigate(-1)}
                  /> */}

      {/* </div> */}
      <div className="main-container">
        <div className="d-flex justify-content-between mb-3">
          <div onClick={() => navigate(-1)} className="admin-header mb-0">
            <img src={leftArrow} className="back-icon-arrow" />
            <h2>Users</h2>
          </div>
          <div>
            {/* ADD BUTTON */}

            <button
              onClick={() => setPopup(true)}
              style={{ backgroundColor: "#F98425" }}
              className="btn text-white fw-semibold px-4 py-2"
            >
              {usertype ? "Special User" : " Normal user"}
              <img
                src={userarrow}
                alt="arrow"
                className="ms-2"
                style={{ width: "16px", height: "16px" }}
              />
            </button>
          </div>
        </div>
        {/* ---------------- PROFILE CARD ---------------- */}
        <div className="profile-card">
          <div className="profile-left">
            <img
              src={data.image || "https://i.pravatar.cc/100"}
              alt="profile"
              className="profile-imgs"
            />
            <div>
              <h2 className="user-name">{data.name}</h2>
              <p className="user-id">{data.user_code}</p>
            </div>
          </div>

          <div className="divider" />

          <div className="profile-middle">
            <p>
              <span>Register Date :</span>{" "}
              <b className="highlight">
                {data.created_at
                  ? new Date(data.created_at)
                      .toLocaleDateString("en-GB")
                      .replace(/\//g, "-")
                  : "-"}
              </b>
            </p>
            <p>
              <span>Address :</span>
              <br />
              <b className="highlight">
                {/* 2nd Floor, No 45, Industrial Estate,
                                <br />
                                Chennai - 600032. */}
                {data.address}
              </b>
            </p>
          </div>

          <div className="profile-right">
            <p>
              <span>Email ID :</span> <b className="highlight">{data.email}</b>
            </p>
            <p>
              <span>Mobile No :</span>{" "}
              <b className="highlight">{data.mobile}</b>
            </p>
          </div>
        </div>

        {/* ---------------- TABLE ---------------- */}
        <h3 className="section-title">Past Trips</h3>

        <MaterialTable columns={columns} data={adminData || []} />

        {/* User Switch Confirmation Popup */}
        {popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <h2 className="f4 mt-4 text-center" style={{ color: "#DE3C1E" }}>
                Change User Type
              </h2>
              {/* <p className="f3 mt-4 text-center" style={{ color: "#0e0d0d" }}>
             You're changing [Vikram] from <br/> 
             Normal User to Special User.
            </p> */}
              <p className="f3 mt-4 text-center" style={{ color: "#0e0d0d" }}>
                You're changing <b>[{data?.name}]</b> from{" "}
                <b>{usertype ? "Special User" : "Normal User"}</b> to{" "}
                <b>{usertype ? "Normal User" : "Special User"}</b>.
              </p>
              <div className="d-flex ac-jb px-2 mt-5">
                <button
                  onClick={() => setPopup(false)}
                  className="delete-btn-cancel w-40"
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleLogout(usertype)}
                  className="delete-btn-confirm  f2 w-40"
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                      ></span>
                    </>
                  ) : (
                    "Confirm"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewUsers;
